<script>
    export default {
        name: "LogoBox",
        props: {
            section: String,
        },
    };
</script>

<template>
    <a class="logo-box" href="/">
        <Logo />
        <div class="title">Lockbox</div>
        <div class="section">{{ section }}</div>
    </a>
</template>


<style lang="scss">
    .logo-box {
        display: inline-grid;
        grid-template-areas:
            "logo title"
            "logo section";
        gap: 0px 15px;

        .logo {
            grid-area: logo;
            width: 65px;
            stroke-width: 3px;
        }

        color: #333;
        font-size: 24px;

        .title {
            grid-area: title;
            font-family: $header-font;
            font-weight: 800;
            align-self: end;
        }

        .section {
            grid-area: section;
            align-self: top;
        }
    }
</style>

